export const clsxs = {
    common: {
        name: clsx.default("text-[24px] text-emphas leading-[40px] font-bold pb-[32px] t-border-b-uicolor4"),
        content: clsx.default("mt-[32px]"),
    },
};
